export function getCurrentCampusCode(currentCampus, campusData) {
  const idx = (currentCampus ?? 1) - 1;
  const list = campusData?.campusList ?? [];
  const fromIndex = list[idx]?.code;
  return (fromIndex && String(fromIndex).toLowerCase()) || "_default";
}

export function getMapNorthOffsetDeg(campusData, currentCampus) {
  return campusData.campusList[currentCampus - 1]?.map.northOffsetDeg ?? 0;
}
